import { gql } from "@apollo/client";
import CartQuantityStepper from "../../../theme/components/CartQuantityStepper";
import ProductItem from "../products/ProductItem";
import { useLocale, useTranslations } from "next-intl";
import ProductPrice from "../products/ProductPrice";

export const CartItemFragment = gql`
  fragment CartItemFragment on OrderItem {
    _id
    dispatches {
      earliestDelivery
    }
    quantity
    total {
      amount
      currency
    }
    configuration {
      key
      value
    }
  }
`;

const CartItem = ({
  onChangeItemQuantity,
  onRemoveItem,
  readonly,
  quantity,
  total,
  product,
  dispatches,
  shouldUseInstitutionalMigelConformity,
  hideAvailability = false,
  configuration = [],
}) => {
  const t = useTranslations();
  const locale = useLocale();
  const deliveryDate =
    dispatches?.[0]?.earliestDelivery &&
    Intl.DateTimeFormat(`${locale}-CH`, {
      dateStyle: "short",
      timeStyle: undefined,
    }).format(new Date(dispatches?.[0]?.earliestDelivery));
  const cuttingJSON = (configuration || []).reduce(
    (accumulator, configurationItem) => {
      if (configurationItem.key === "cutting") return configurationItem.value;
      return accumulator;
    },
    undefined,
  );
  const cutting = cuttingJSON && JSON.parse(cuttingJSON || "[]");
  return (
    <ProductItem
      {...product}
      shouldUseInstitutionalMigelConformity={
        shouldUseInstitutionalMigelConformity
      }
      hideAvailability={hideAvailability}
      quantity
      cutting={cutting}
    >
      <div className="product-item__more">
        <ProductPrice price={total} />

        <div className="text-end mt-2">
          <small className="fs-8 color-primary-dimmed d-inline-block">
            {t("order_estimated_delivery_date")}
          </small>
          <div className="fw-semibold">{deliveryDate}</div>
        </div>
        {!readonly ? (
          ""
        ) : (
          <div className="gap-2 product-item__more__amount">
            <small className="fs-8 color-primary-dimmed d-inline-block">
              {t("quantity")}
            </small>
            <div className="fw-semibold">{quantity}</div>
          </div>
        )}
      </div>
      <div className="product-item__action ">
        {!readonly ? (
          <CartQuantityStepper
            quantity={quantity}
            onQuantityChanged={onChangeItemQuantity}
            onRemove={onRemoveItem}
          />
        ) : (
          ""
        )}
      </div>
    </ProductItem>
  );
};

export default CartItem;
